import {
  HERO_SLIDER,
  HERO_SLIDER_SUCCESS,
  HERO_SLIDER_ERROR,
  FETCH_FRONT_MENU,
  FETCH_FRONT_MENU_SUCCESS,
  FETCH_FRONT_MENU_ERROR,
  FETCH_PARENT_CATEGORIES,
  FETCH_PARENT_CATEGORIES_SUCCESS,
  FETCH_PARENT_CATEGORIES_ERROR,
  FETCH_BRANDS,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_ERROR,
  FETCH_HIGHLIGHTS,
  FETCH_HIGHLIGHTS_SUCCESS,
  FETCH_HIGHLIGHTS_ERROR,
  MOST_POPULAR,
  MOST_POPULAR_SUCCESS,
  MOST_POPULAR_ERROR,
  FETCH_CATEGORY_TREE,
  FETCH_CATEGORY_TREE_SUCCESS,
  FETCH_CATEGORY_TREE_ERROR,
  FETCH_CATEGORY_FILTERS,
  FETCH_CATEGORY_FILTERS_SUCCESS,
  FETCH_CATEGORY_FILTERS_ERROR,
  FETCH_DAILY_DEALS,
  FETCH_DAILY_DEALS_SUCCESS,
  FETCH_DAILY_DEALS_ERROR,
  FETCH_COUPON_DETAILS,
  FETCH_COUPON_DETAILS_SUCCESS,
  FETCH_COUPON_DETAILS_ERROR,
} from '../actionTypes';

const INIT_STATE = {
  carousel: [],
  error: '',
  loading: false,
  frontMenu: [],
  parentCategories: [],
  brands: [],
  highlights: [],
  mostPopularItems: [],
  categoryTree: [],
  dailyDeals: [],
  filtersLoading: false,
  categoryFilters: null,
  coupons: [],
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case HERO_SLIDER:
      return { ...state, loading: true, error: '' };
    case HERO_SLIDER_SUCCESS:
      return {
        ...state,
        loading: false,
        carousel: action.payload,
        error: '',
      };
    case HERO_SLIDER_ERROR:
      return {
        ...state,
        loading: false,
        carousel: null,
        error: action.payload.message,
      };
    case FETCH_FRONT_MENU:
      return { ...state, loading: true, error: '' };
    case FETCH_FRONT_MENU_SUCCESS:
      return {
        ...state,
        loading: false,
        frontMenu: action.payload,
        error: '',
      };
    case FETCH_FRONT_MENU_ERROR:
      return {
        ...state,
        loading: false,
        frontMenu: null,
        error: action.payload.message,
      };
    case FETCH_PARENT_CATEGORIES:
      return { ...state, loading: true, error: '' };
    case FETCH_PARENT_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        parentCategories: action.payload,
        error: '',
      };
    case FETCH_PARENT_CATEGORIES_ERROR:
      return {
        ...state,
        loading: false,
        parentCategories: null,
        error: action.payload.message,
      };
    case FETCH_BRANDS:
      return { ...state, loading: true, error: '' };
    case FETCH_BRANDS_SUCCESS:
      return {
        ...state,
        loading: false,
        brands: action.payload,
        error: '',
      };
    case FETCH_BRANDS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case FETCH_HIGHLIGHTS:
      return { ...state, loading: true, error: '' };
    case FETCH_HIGHLIGHTS_SUCCESS:
      return {
        ...state,
        loading: false,
        highlights: action.payload,
        error: '',
      };
    case FETCH_HIGHLIGHTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case MOST_POPULAR:
      return { ...state, loading: true, error: '' };
    case MOST_POPULAR_SUCCESS:
      return {
        ...state,
        loading: false,
        mostPopularItems: action.payload,
        error: '',
      };
    case MOST_POPULAR_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case FETCH_CATEGORY_TREE:
      return { ...state, loading: true, error: '' };
    case FETCH_CATEGORY_TREE_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryTree: action.payload,
        error: '',
      };
    case FETCH_CATEGORY_TREE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case FETCH_CATEGORY_FILTERS:
      return { ...state, filtersLoading: true, error: '' };
    case FETCH_CATEGORY_FILTERS_SUCCESS:
      return {
        ...state,
        filtersLoading: false,
        categoryFilters: action.payload,
        error: '',
      };
    case FETCH_CATEGORY_FILTERS_ERROR:
      return {
        ...state,
        filtersLoading: false,
        error: action.payload.message,
      };
    case FETCH_DAILY_DEALS:
      return { ...state, loading: true, error: '' };
    case FETCH_DAILY_DEALS_SUCCESS:
      return {
        ...state,
        loading: false,
        dailyDeals: [...action.payload.deals],
        error: '',
      };
    case FETCH_DAILY_DEALS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case FETCH_COUPON_DETAILS:
      return { ...state, loading: true, error: '' };
    case FETCH_COUPON_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: [...action.payload],
        error: '',
      };
    case FETCH_COUPON_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};

export default reducer;
